import React, { useMemo } from 'react';

const ALLOWED_DOMAINS = ['youtube.com', 'www.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com', 'drive.google.com', 'docs.google.com'];

function extractIframeSrc(html) {
    if (!html || typeof html !== 'string') return null;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const iframe = doc.querySelector('iframe');

    if (!iframe) return null;

    return iframe.getAttribute('src') || null;
}

function isAllowedUrl(src) {
    if (!src) return false;

    try {
        const url = new URL(src, window.location.origin);

        if (url.protocol !== 'https:' && url.protocol !== 'http:') return false;

        return ALLOWED_DOMAINS.some((domain) => url.hostname === domain || url.hostname.endsWith('.' + domain));
    } catch {
        return false;
    }
}

export default function SafeIframe({ html }) {
    const src = useMemo(() => {
        const extracted = extractIframeSrc(html);
        if (extracted && isAllowedUrl(extracted)) return extracted;
        return null;
    }, [html]);

    if (!src) {
        return <div className="text-color-secondary text-sm">Geçersiz veya desteklenmeyen video bağlantısı</div>;
    }

    return (
        <iframe
            src={src}
            title="Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox allow-forms"
            referrerPolicy="strict-origin-when-cross-origin"
            loading="lazy"
        />
    );
}
